/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ComplaintProperties, GetComplaintsGeojsonRequest, GetComplaintsGeojsonState } from "store/modules/complaints/types";

const initialState: GetComplaintsGeojsonState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const getComplaintsGeojsonSlice = createSlice({
    name: "complaints@getComplaintsGeojson",
    initialState,
    reducers: {
        getComplaintsGeojsonRequest: (
            state,
            action: PayloadAction<GetComplaintsGeojsonRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getComplaintsGeojsonSuccess: (
            state,
            action: PayloadAction<GeoJSON.FeatureCollection<GeoJSON.Point, ComplaintProperties>>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getComplaintsGeojsonFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    getComplaintsGeojsonFailed,
    getComplaintsGeojsonRequest,
    getComplaintsGeojsonSuccess
} = getComplaintsGeojsonSlice.actions;
export default getComplaintsGeojsonSlice.reducer;
